(function () {
  "use strict";

  var PLAY_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">' +
    '<path d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" fill="#fff"/>' +
    '<path d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" fill="#fff"/>' +
    "</svg>";

  var grid, moreBtn, emptyEl, chips;
  var pageSize = 12;
  var state = { category: "", page: 1, loading: false };

  function init() {
    grid = document.querySelector("[data-all-videos-grid]");
    if (!grid) return;
    if (
      typeof API_URL === "undefined" ||
      typeof API_Header_Options === "undefined"
    ) {
      // Globals from global-variables.liquid may not be parsed yet.
      setTimeout(init, 100);
      return;
    }

    moreBtn = document.querySelector("[data-all-videos-more]");
    emptyEl = document.querySelector("[data-all-videos-empty]");
    chips = Array.prototype.slice.call(
      document.querySelectorAll(".all-videos__chip")
    );
    pageSize = parseInt(grid.dataset.pageSize, 10) || 12;

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        if (state.loading || chip.classList.contains("is-active")) return;
        chips.forEach(function (c) {
          c.classList.remove("is-active");
          c.setAttribute("aria-pressed", "false");
        });
        chip.classList.add("is-active");
        chip.setAttribute("aria-pressed", "true");
        state.category = chip.dataset.category || "";
        state.page = 1;
        grid.innerHTML = "";
        loadPage(true);
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener("click", function () {
        if (state.loading) return;
        state.page += 1;
        loadPage(false);
      });
    }

    loadPage(true);
  }

  function buildUrl() {
    var url =
      API_URL +
      "social-media-posts?filter[source]=YOUTUBE&includes=newsCategories&sort=-publishedAt" +
      "&page[number]=" +
      state.page +
      "&page[size]=" +
      pageSize;
    if (state.category) {
      url += "&filter[newsCategoryName][]=" + encodeURIComponent(state.category);
    }
    return url;
  }

  function loadPage(replace) {
    state.loading = true;
    if (emptyEl) emptyEl.hidden = true;
    if (moreBtn) moreBtn.hidden = true;
    if (replace) showSkeleton();

    fetch(buildUrl(), API_Header_Options)
      .then(function (res) {
        if (!res.ok) throw new Error("API error: " + res.status);
        return res.json();
      })
      .then(function (response) {
        if (replace) grid.innerHTML = "";
        var videos = normalize(response);
        videos.forEach(function (video) {
          grid.appendChild(createCell(video));
        });

        var isEmpty = replace && videos.length === 0;
        if (emptyEl) emptyEl.hidden = !isEmpty;
        // A full page suggests more results; a short page is the last one.
        if (moreBtn) moreBtn.hidden = videos.length < pageSize;
      })
      .catch(function (err) {
        console.error("All videos error:", err);
        if (replace) {
          grid.innerHTML = "";
          if (emptyEl) emptyEl.hidden = false;
        }
      })
      .finally(function () {
        state.loading = false;
      });
  }

  function showSkeleton() {
    // First load: keep the server-rendered placeholder cells (same size as the
    // cards, so nothing moves); the JS skeleton is only for filter changes.
    if (grid.querySelector(".all-videos__cell--skeleton")) return;
    grid.innerHTML =
      '<div class="video-skeleton all-videos__skeleton">' +
      new Array(Math.min(pageSize, 8) + 1).join(
        '<div class="video-skeleton__card"></div>'
      ) +
      "</div>";
  }

  function normalize(response) {
    if (!response || !response.data) return [];
    return response.data
      .map(function (entry) {
        var data = entry.attributes && entry.attributes[0];
        if (!data || !data.videoUrl) return null;
        return {
          id: data.id || entry.id,
          title: data.title || "",
          imageUrl:
            data.imageUrl ||
            (typeof defaultPlaceHolder !== "undefined" ? defaultPlaceHolder : ""),
          publishedAt: data.publishedAt || "",
        };
      })
      .filter(Boolean);
  }

  function formatDate(value) {
    if (!value) return "";
    var date = new Date(value.replace(" ", "T"));
    if (isNaN(date)) return "";
    return date.toLocaleDateString("de-CH", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }

  function createCell(video) {
    var cell = document.createElement("div");
    cell.className = "all-videos__cell";
    var dateLabel = formatDate(video.publishedAt);
    cell.innerHTML =
      '<a class="video-card" href="' +
      videoPageURL +
      "/" +
      encodeURIComponent(video.id) +
      '" aria-label="' +
      escapeHtml(video.title) +
      '">' +
      '<div class="video-card__media">' +
      '<img src="' +
      escapeHtml(video.imageUrl) +
      '" alt="' +
      escapeHtml(video.title) +
      '" loading="lazy" />' +
      "</div>" +
      '<span class="video-card__play">' +
      PLAY_ICON_SVG +
      "</span>" +
      '<h3 class="video-card__title">' +
      escapeHtml(video.title) +
      "</h3>" +
      (dateLabel
        ? '<span class="all-videos__date">' + dateLabel + "</span>"
        : "") +
      "</a>";
    return cell;
  }

  function escapeHtml(str) {
    if (!str) return "";
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
